/* istanbul ignore file */
import React, { useEffect } from 'react';
import { get } from 'lodash';
import Table from '@material-ui/core/Table';
import { connect, useSelector } from 'react-redux';
import TablePagination from '@material-ui/core/TablePagination';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { IntlShape, injectIntl } from 'react-intl';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardTitle from 'containers/common/Card/CardTitle';
import { Container } from 'containers/ManagerManagement/styles';
import { translate } from 'containers/services/translate';
import messages from 'containers/ManagerManagement/messages';
import { ROW_PER_PAGE } from 'constants/global';
import { requestSetPrivilegesManager } from 'containers/ManagerManagement/actions';
import { requestGetManagersBawaba } from 'containers/AttributionManager/action';
import { makeSelectManagers } from 'containers/AttributionManager/selector';
import { renderRoles } from 'containers/ManagerManagement/utils';
import RoleManagementDialog from 'containers/ManagerManagement/RoleManagementDialog';

export interface ManagerManagementProps {
  intl: IntlShape;
  requestGetManagersBawaba: Function;
  requestSetPrivilegesManager: Function;
}

export const ManagerManagement: React.FC<ManagerManagementProps> = (
  props,
): JSX.Element => {
  const [page, setPage] = React.useState(0);
  const [pageSize, setRowsPerPage] = React.useState(25);
  const [OpenPoping, setOpenPoping] = React.useState(false);
  const [selectedManager, setSelectedManager] = React.useState({});
  const managers = useSelector(makeSelectManagers());
  useEffect(() => {
    props.requestGetManagersBawaba({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const size = parseInt(event.target.value, 10);
    setRowsPerPage(size);
  };
  const handleClose = () => {
    setOpenPoping(false);
    setSelectedManager({});
  };
  return (
    <Container>
      <Card>
        <CardContent>
          <div className="header">
            <CardTitle message={translate({ ...messages.title }, props)} />
          </div>
          <div>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left" className="headerTitle">
                    {translate({ ...messages.nameTitle }, props)}
                  </TableCell>
                  <TableCell align="left" className="headerTitle">
                    {translate({ ...messages.rolesTitle }, props)}
                  </TableCell>
                  <TableCell align="left" className="headerTitle">
                    {translate({ ...messages.actionTitle }, props)}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {managers.map((row: any) => (
                  <TableRow key={row.id}>
                    <TableCell align="left" className="row">
                      {get(row, 'sagisName')}
                    </TableCell>
                    <TableCell align="left" className="row">
                      {renderRoles(get(row, 'dataValues'))}
                    </TableCell>
                    <TableCell
                      align="left"
                      className="action-row"
                      data-testId="button-action"
                      onClick={() => {
                        setOpenPoping(true);
                        setSelectedManager(row);
                      }}
                    >
                      {'Actions'}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={ROW_PER_PAGE}
              component="div"
              count={managers.length}
              rowsPerPage={pageSize}
              page={page}
              labelRowsPerPage={translate({ ...messages.linesPerPage }, props)}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
            <RoleManagementDialog
              open={OpenPoping}
              handleClose={handleClose}
              requestSetPrivilegesManager={props.requestSetPrivilegesManager}
              selectedManager={selectedManager}
              requestGetManagersBawaba={props.requestGetManagersBawaba}
            />
          </div>
        </CardContent>
      </Card>
    </Container>
  );
};

const mapDispatchToProps = {
  requestGetManagersBawaba,
  requestSetPrivilegesManager,
};

export default connect(null, mapDispatchToProps)(injectIntl(ManagerManagement));
